import { render, staticRenderFns } from "./Registrationuser.vue?vue&type=template&id=ed9ded6a&scoped=true&"
import script from "./Registrationuser.vue?vue&type=script&lang=js&"
export * from "./Registrationuser.vue?vue&type=script&lang=js&"
import style0 from "./Registrationuser.vue?vue&type=style&index=0&id=ed9ded6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9ded6a",
  null
  
)

export default component.exports